var FOOTER_CLICK_CODES = {
  NpayDownloadButton: 'fot.payapp'
};

export { FOOTER_CLICK_CODES };
